import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  DISCOUNT_CODE_CATEGORY_PATH,
  NEW_DISCOUNT_CODE_CATEGORY_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DISCOUNT_CODE_CATEGORY_COLUMNS } from '../../../../config/columns';

import {
  clearDiscountCodeCategories,
  getDiscountCodeCategories,
} from '../../../../actions/sales/DiscountCodeCategory';

export const DiscountCodeCategories = ({
  breadcrumbs,
  discountCodeCategories,
  loading,
  dispatchGetDiscountCodeCategories,
  dispatchClearDiscountCodeCategories,
}) => {
  useLayoutEffect(() => () => dispatchClearDiscountCodeCategories(), []);

  const data = discountCodeCategories.get('content') || [];
  const pages = discountCodeCategories.get('totalPages') || null;
  const defaultPageSize =
    discountCodeCategories.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Categoría de Códigos de Descuento"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_DISCOUNT_CODE_CATEGORY_PATH}
      tableStructure={{
        columns: DISCOUNT_CODE_CATEGORY_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetDiscountCodeCategories,
        modelPath: DISCOUNT_CODE_CATEGORY_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetDiscountCodeCategories: getDiscountCodeCategories,
  dispatchClearDiscountCodeCategories: clearDiscountCodeCategories,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categoría de Códigos de Descuento',
      href: DISCOUNT_CODE_CATEGORY_PATH,
    },
  ],
  discountCodeCategories: SalesUnit.DiscountCodeCategory.getIn([
    'all',
    'content',
  ]),
  loading: SalesUnit.DiscountCodeCategory.getIn(['all', 'loading']),
});

DiscountCodeCategories.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  discountCodeCategories: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetDiscountCodeCategories: PropTypes.func.isRequired,
  dispatchClearDiscountCodeCategories: PropTypes.func.isRequired,
};

DiscountCodeCategories.defaultProps = {
  discountCodeCategories: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountCodeCategories);
